/**
 * @hidden
 **/
var _TimeToken = /** @class */ (function () {
    function _TimeToken() {
        this._timeElapsedQueryEnded = false;
    }
    return _TimeToken;
}());
export { _TimeToken };
//# sourceMappingURL=timeToken.js.map